import React, { useState, useEffect } from 'react';
import { Button, TextField, Container, Grid, Box, Typography } from '@mui/material';

function App() {
  const [players, setPlayers] = useState([]);
  const [newPlayerName, setNewPlayerName] = useState('');

  // Load data from localStorage on component mount
  useEffect(() => {
    const savedPlayers = localStorage.getItem('golfScores');
    if (savedPlayers) {
      setPlayers(JSON.parse(savedPlayers));
    }
  }, []);

  // Update localStorage whenever players data changes
  useEffect(() => {
    if (players.length > 0) {
      localStorage.setItem('golfScores', JSON.stringify(players));
    }
  }, [players]);

  // Add a new player
  const addPlayer = () => {
    if (!newPlayerName) return;

    const newPlayer = {
      name: newPlayerName,
      score: 0,
    };
    setPlayers([...players, newPlayer]);
    setNewPlayerName('');
  };

  // Change score for a player
  const changeScore = (index, change) => {
    const updatedPlayers = [...players];
    updatedPlayers[index].score += change;
    setPlayers(updatedPlayers);
  };

  // Clear all players' scores
  const clearAll = () => {
    if (window.confirm('Are you sure you want to clear all records?')) {
      setPlayers([]);
      localStorage.removeItem('golfScores');
    }
  };

  // Clear rounds
  const clearRounds = () => {
    if (window.confirm('Are you sure you want to clear all rounds?')) {
      setPlayers(players.map(player => ({ ...player, score: 0 })));
    }
  };

  return (
    <Container maxWidth="md" 
      sx={{
        mt: 4,
        height: '100vh',
        fontWeight: 'bold',
      }}
      >
      <Typography variant="h4" align="center" gutterBottom>
        Birdy Golf Score Tracker
      </Typography>

      {/* Player List */}
      <Grid container spacing={2} justifyContent="center">
        {players.map((player, index) => (
          <Grid item key={index} size={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderRadius: '8px',
                padding: 1,
                outline: '1px solid #ccc',
              }}
            >
              <Typography variant="h6">{player.name}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => changeScore(index, -1)}
                  sx={{
                    borderRadius: '8px',
                  }}
                >
                  -
                </Button>
                <Typography variant="body1" sx={{ width: 40, textAlign: 'center' }}>
                  {player.score}
                </Typography>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => changeScore(index, 1)}
                  sx={{
                    borderRadius: '8px',
                  }}
                >
                  +
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={clearRounds}
          sx={{
            borderRadius: '8px',
          }}>
          Clear Round
        </Button>
      </Box>

      {/* Clear Button */}
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Button variant="contained" color="secondary" onClick={clearAll}
        sx={{
          borderRadius: '8px',
        }}
        >
          Clear All Records
        </Button>
      </Box>

      

            {/* Player Input */}
        <Box sx={{
            position: 'absolute', // Position the box absolutely
            bottom: 0, // Align it to the bottom
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            mb: 3,
          }}>
          <TextField
            label="Player Name"
            variant="outlined"
            value={newPlayerName}
            onChange={(e) => setNewPlayerName(e.target.value)}
            fullWidth
          />
          <Button variant="contained" color="primary" onClick={addPlayer}>
            Add
          </Button>
        </Box>
    </Container>
  );
}

export default App;
